import { AssetLoader, PaymentCardImageTypes } from '@mews/framework';

export enum PaymentMethodImageType {
    Ideal = 'ideal',
    PaymentCard = 'card',
    ApplePay = 'applePay',
    GooglePay = 'googlePay',
    SepaDirectDebit = 'sepa',
    PayPal = 'paypal',
}

export interface PaymentMethodImageTypeProps {
    className?: string;
    type: PaymentMethodImageType | keyof PaymentCardImageTypes;
    assetLoader?: AssetLoader;
    small?: boolean;
}
